import React, { useState, useEffect, Fragment, memo, useRef, PureComponent, useMemo, useCallback, JSX, ReactElement } from "react"
import { alpha, AppBar, Box, Container, Dialog, Paper, DialogContent, InputBase, styled, Toolbar, Typography, useMediaQuery, useTheme, LinearProgress, IconButton, Theme, List, Divider, ListItem, Stack, ListItemButton, ListItemIcon, Checkbox, ListItemAvatarProps, ListItemTextProps, ListItemText, Skeleton, CircularProgress, Grid, Switch, FormControlLabel, Button, Menu, MenuItem, ToolbarPropsVariantOverrides } from "@mui/material"
import { Search, Add, AddCircleOutline, RefreshRounded, Delete, Close, WarningAmber, Filter, FilterList, ArrowBack, KeyboardArrowDown } from "@mui/icons-material"
import { DataGrid, GridColDef, GridDensity, GridRowHeightParams, GridRowSelectionModel, gridClasses, GridToolbar, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import { makeStyles } from "tss-react/mui";
import Alerts from "../alerts/Alerts";
import FiltroView, { OwnPropsFiltroView } from "../filtroView"
import { displayBreakpoints, displayBreakpointsValues, getKeyValue, getNewId } from "../../services/utils";

import ViewForm from "../viewCadastro/viewForm";
import { FormCadProps } from "../viewCadastro/formCad";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";

const useStyles = makeStyles()((theme: Theme) => ({
    showList: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flex: 1,
        }
    },
    showTable: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            flex: 1,
            height: '100%'
        }
    },
    title: {
        width: "85%", 
        flex: 1,
        marginLeft: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            fontSize: '90%',
        }
    },
}));

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    cursor: "pointer"
}))

const MyPaper = styled(Paper)(({ theme }) => ({
    height: '100%'
}))

const SearchContainer = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',
        display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));
const SearchContainerMobile = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    display: 'none',
    [theme.breakpoints.down('sm')]: {
        display: 'flex'
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
}));

export interface SelectProps {
    title: string;
    subtitle?: string;
    rows: any[];
    row: any;
    displayWidth: number;
    setRow: (row: any) => void;
    columns: GridColDef[],
    getRowId: (row: any) => string;
    gridGetRowHeigth?: any;
    actionsOnkeyEnter?: (row: any) => void;
    textSearch: string;
    placeholderTextSearch?: string;
    setTextSearch: (text: string) => void;
    multFieldSearch?: boolean
    fieldSearch: any
    handleOnChange: (value: any) => void;
    handleDobleClick?: (row: any) => void
    showSearchContainer: boolean
    showAlert: boolean
    closeAlert: () => void
    msg: string;
    status: string;
    loading: boolean;
    elevation?: number;
    fontSize?: number
    buttonNew: {
        show: boolean;
        onClick: (prm?: any) => void
    }
    buttonRefresh: {
        show: boolean;
        onClick: () => void
    }
    checkbox?: {
        rowsSelect: Array<any>,
    }
    buttonMenu?: {
        show: boolean
        label: string
        icon: any
        menu: Array<{
            label: string
            onClick: () => void
            icon: any
        }>
    }
    showButtonBack?: boolean,
    handleClose?: () => void;
    handleRemove?: (row: any) => void
    ListItemAvatar?(row: any): JSX.Element
    ListItemTextPrimary(row: any): JSX.Element
    ListItemTextSecondary?: (row: any) => JSX.Element
    handleClickOculto?: () => void;
    showFullFiltroForm?: boolean;
    fullFiltroFormParams?: OwnPropsFiltroView
    handleShowFiltroForm?: () => void;
    labelEnableUpdateLote?: string;
    showUpdateLote?: boolean
    rowsUpdateLote?: any[],
    setRowsUpdateLote?: (value: any) => any
    formUpdateLote?: FormCadProps
    /* função para retornar os dados filtrados */
    setDataFiltered?: (rows: any) => any
    filterFromDb?: (value: string, fieldFilter: string, limit?: number) => Promise<{ status: any, rows: any[], msg?: string }>
    autoPageSize?: boolean
    changeList: string//valor data para indicar que algum valor na lista foi alterado
    variantToobar?: "dense" | "regular"
    ViewBeforeGridList?: () => JSX.Element
    hidenGridNoData?: boolean
    orderBy?: string
}

const SkeletonList = () => {
    const { classes } = useStyles()
    const number: any[] = [1, 2, 3];
    return (
        <Box className={classes.showList} sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            {
                number.map(value => (
                    <Box key={value} sx={{ display: 'flex', flexDirection: 'column', padding: 1 }}>
                        <Skeleton animation="wave" height={40} />
                        <Skeleton animation="wave" />
                        <Skeleton animation="wave" width="80%" height={10} />
                    </Box>
                ))
            }
        </Box>
    )
}

const SkeletonTable = () => {
    const { classes } = useStyles()
    const number: any[] = [1, 2, 3];
    return (
        <Box className={classes.showTable} sx={{ display: 'flex', flexDirection: 'column', flex: 1, padding: 1 }}>
            {
                number.map(value => (
                    <Stack key={value} direction="row" spacing={1}>
                        <Skeleton animation="wave" width="10%" />
                        <Skeleton animation="wave" width="60%" />
                        <Skeleton animation="wave" width="40%" />
                    </Stack>
                ))
            }
        </Box>
    )
}

const NoDataShow = () => {
    return (
        <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center' }}>
            <WarningAmber sx={{ alignSelf: 'center', fontSize: 50 }} />
            <Typography sx={{ alignSelf: 'center' }} component={"div"} variant="button">Não à dados para ser exibido.</Typography>
        </Box>
    )
}
interface ShowListDataProps {
    rowsFilter: any[],
    handleRemove?: (row: any) => void
    checkbox?: {
        rowsSelect: Array<any>,
    }
    ListItemAvatar?(row?: any): JSX.Element
    ListItemTextPrimary(row: any): JSX.Element
    ListItemTextSecondary?: (row: any) => JSX.Element
    actionsOnkeyEnter?: (row: any) => void;
    rowIndex: any
    lenghtList: number,
}

const ShowListData = (props: ShowListDataProps) => {
    const { ListItemTextPrimary, rowsFilter, ListItemAvatar, ListItemTextSecondary, checkbox, handleRemove, actionsOnkeyEnter, rowIndex, lenghtList } = props
    return (
        <List id="list" dense sx={{ flex: 1 }}>
            {rowsFilter.map((data, index) => {
                if (index <= lenghtList)
                    return (
                        <div key={index}>
                            <ListItem
                                key={index}
                                alignItems="flex-start"
                                secondaryAction={
                                    handleRemove && (
                                        <IconButton color={'error'} edge="end" aria-label="delete" onClick={() => handleRemove(data)}>
                                            <Delete />
                                        </IconButton>
                                    )
                                }

                            >
                                <ListItemButton role={undefined} onClick={() => actionsOnkeyEnter && actionsOnkeyEnter(data)} dense disableGutters>
                                    {checkbox && (
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                checked={checkbox.rowsSelect.findIndex(select => data[rowIndex] === select[rowIndex]) !== -1}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{ 'aria-labelledby': `checkbox-list-label-${data[rowIndex]}` }}
                                            />
                                        </ListItemIcon>
                                    )}
                                    {ListItemAvatar && (
                                        ListItemAvatar(data)
                                    )}
                                    <ListItemText
                                        primary={ListItemTextPrimary(data)}
                                        secondary={ListItemTextSecondary ? (ListItemTextSecondary(data)) : (undefined)}
                                    />

                                </ListItemButton>
                            </ListItem>
                            <Divider />
                        </div>
                    )
            }
            )}
        </List>

    )
}
interface SelectState {
    indexRow: number
    rowIdIndex: string
    rowsFilter: Array<any>
    textFilter: any
    loadingFilter: boolean
    sizeShowList: number
}
var _callFilterRow: any;

const ODD_OPACITY = 0.2;

export const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[300],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));

export function Select(props: SelectProps) {
    const { title, subtitle, rows, columns, getRowId, handleOnChange, setTextSearch, textSearch, actionsOnkeyEnter, row, setRow, loading, fieldSearch, multFieldSearch, buttonNew, buttonRefresh, fontSize, showSearchContainer, ListItemTextPrimary, ListItemTextSecondary, ListItemAvatar, checkbox, handleRemove, handleClose, closeAlert, msg, showAlert, status, elevation, handleClickOculto, displayWidth, gridGetRowHeigth, showFullFiltroForm, fullFiltroFormParams, handleShowFiltroForm, showButtonBack, showUpdateLote, rowsUpdateLote, setRowsUpdateLote, formUpdateLote, buttonMenu, setDataFiltered, placeholderTextSearch, labelEnableUpdateLote, filterFromDb, autoPageSize, changeList, variantToobar, ViewBeforeGridList, hidenGridNoData, handleDobleClick, orderBy } = props
    const [state, setState] = useState<SelectState>({
        indexRow: rows.length > 0 ? 0 : -1,
        rowIdIndex: rows.length > 0 ? rows[0]._id : '',
        rowsFilter: [],
        textFilter: '',
        loadingFilter: false,
        sizeShowList: 25,
    });
    const [updateLote, setUpdateLote] = useState(false);
    const { classes } = useStyles();
    const theme = useTheme();
    const inputRef = useRef(null);
    var _fieldSearch = multFieldSearch ? fieldSearch[0] : fieldSearch;
    var selecionou = false;//será marcado quando um item for selecionado
    //e desmarcado quando o item for add a lista

    useEffect(() => {
        //console.log("useEffect em select",[rows,changeList])
        let resp = odering(rows);
        setState(state => ({ ...state, rowsFilter: resp }))
        setDataFiltered && setDataFiltered(resp);
    }, [changeList])//changeList indica que a lista deve ser regarregada

    const handleSetUpdateLote = (set: boolean) => {
        setUpdateLote(set);
        if (!set) {
            //se for desabilitar desmarcar todos os itens selecionados
            setRowsUpdateLote && setRowsUpdateLote([])
        }
    }

    const getDataFieldSearch = (value: any) => {
        if (multFieldSearch) {
            //verificar se existe o caracters #(hashtag) na primeira posiçao é para buscar 
            //no fildSearch[0]
            let word: string = value;
            if (word.startsWith("#", 0)) {
                _fieldSearch = fieldSearch[1]
                return word.slice(1, word.length)
            } else {
                //se nao for numero é busca por text index 0 do fieldSearch
                if (isNaN(value)) {
                    _fieldSearch = fieldSearch[0]
                } else {
                    _fieldSearch = fieldSearch[1]
                }
            }
        } else {
            _fieldSearch = fieldSearch
        }
        return value
    }

    const odering = (rowsToOrder: any[]) => {
        let order: any = orderBy
        if (order === undefined) {
            order = _fieldSearch;
        }
        if (rowsToOrder.length > 0) {
            let itens = [...rowsToOrder];
            let resp = itens.sort(
                (a: any, b: any) => {
                    let fieldA, fieldB: any;
                    fieldA = getKeyValue(a, order);
                    fieldB = getKeyValue(b, order);
                    if (fieldA > fieldB)
                        return 1
                    else if (fieldB > fieldA)
                        return -1
                    else
                        return 0
                }
            )
            return resp;
        } else {//se nao tiver registro, limpa para nao ficar resido de outras chamadas anteriores
            return []
        }
    }

    const handleFilterRow = (value: string) => {

        if (_callFilterRow) {
            clearInterval(_callFilterRow);
        }

        _callFilterRow = setTimeout(() => {
            clearInterval(_callFilterRow);
            setState(state => ({ ...state, loadingFilter: true }))
            filterRow(getDataFieldSearch(value));
        }, 500)
    }

    const filterRow = async (value: string) => {
        var filter: any[] = []
        if (filterFromDb) {
            let find = await filterFromDb(value, _fieldSearch);
            filter = odering(find.rows)
        } else {
            filter = odering(rows.filter(row => {
                return getKeyValue(row, _fieldSearch).toLowerCase().includes(value.toLocaleLowerCase());
            }))
        }
        if (filter.length > 0 && filter.length > state.indexRow && state.indexRow > -1) {
            setState(state => ({ ...state, rowIdIndex: filter[state.indexRow]._id, rowsFilter: filter, loadingFilter: false }))
        } else {
            setState(state => ({ ...state, rowsFilter: filter, loadingFilter: false }))
        }
        setDataFiltered && setDataFiltered(filter);

    }

    const onKeyDown = (keycode: number) => {

        if (state.rowsFilter.length > 0) {
            let index = state.indexRow;
            const setPosition = () => {
                //se for menor que não contabilizar, permanece com 0
                if (index < -1) index = -1;

                //se for maior que a quantidade de registro, mantem o ultimo
                if (index >= state.rowsFilter.length) {
                    index = state.rowsFilter.length - 1
                }

                if (index > -1) {
                    //verificar se existe o campo _id na raiz do objeto
                    if (state.rowsFilter[index]._id)
                        setState(state => ({ ...state, rowIdIndex: state.rowsFilter[index]._id }))
                    else {
                        let findValueId = getRowId(state.rowsFilter[index]);
                        setState(state => ({ ...state, rowIdIndex: findValueId }));
                    }
                }
                setState(state => ({ ...state, indexRow: index }))
            }

            switch (keycode) {
                case 40://seta para baixo
                    index++
                    setPosition();
                    break;
                case 38://seta para cima
                    index--
                    setPosition();
                    break
                case 13://enter
                    if (actionsOnkeyEnter !== undefined) {
                        actionsOnkeyEnter(state.rowsFilter[state.indexRow]);
                    }
                    break

            }
        }
    }

    const calcShowList = (posScroll: number, lengthScroll: number) => {
        let diff = lengthScroll - posScroll;
        if (diff <= 500) {
            setState(state => ({ ...state, sizeShowList: state.sizeShowList + 25 }))
        }
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
            </GridToolbarContainer>
        );
    }

    const TableListShow = useCallback((list: any[]) => {
        //console.log("itens",list)
        return (
            <StripedDataGrid

                rows={list}
                columns={columns}
                getRowId={getRowId}
                density={'compact'}
                style={{ fontSize: fontSize ? fontSize : '0.875rem' }}
                hideFooterPagination={true}
                hideFooter={true}
                //rowCount={state.rowsFilter.length}
                filterMode="client"
                getRowHeight={() => gridGetRowHeigth}
                //rowSelectionModel={!updateLote ? state.rowIdIndex : rowsUpdateLote}
                onRowDoubleClick={(ev) => { console.log("chamou row double click", ev.row); handleDobleClick && handleDobleClick(ev.row) }}
                onRowClick={(ev) => {
                    //console.log("chamou row click", ev.row)
                    let eventExec = false;
                    if (updateLote) {
                        selecionou = true
                    }
                    if (actionsOnkeyEnter && !updateLote) {
                        console.log("chamou actionsOnkeyEnter", ev.row)
                        actionsOnkeyEnter(ev.row);
                        eventExec = true
                    }
                    if (handleOnChange && !eventExec) {
                        console.log("chamou handleOnChange", ev.row)
                        handleOnChange(ev.row)
                    }
                }}
                checkboxSelection={updateLote}
                onRowSelectionModelChange={(rowSelection) => {
                    //Essa variavel corrige o bug de a grade desmarcar itens quando
                    //um filtro é realizado, entao ela somente seleciona ou deseleciona 
                    //de acordo com a var selecionou
                    if (selecionou)
                        setRowsUpdateLote && setRowsUpdateLote(rowSelection)
                    selecionou = false
                }}
                onColumnHeaderClick={((pr, ev) => {
                    //verificar se é a coluna de select all
                    if (pr.field === "__check__") {
                        selecionou = true
                    }
                })}
                pageSizeOptions={[25, 50, 100]}
                autoPageSize={autoPageSize}
                slots={{ toolbar: CustomToolbar }}
                slotProps={{
                    toolbar: {
                        csvOptions: {
                            fileName: 'exportarDadosMygas',
                            delimiter: ';',
                            utf8WithBom: true,
                            allColumns: true,
                        },
                    },

                }}
            //paginationMode="client"
            />
        )
    }, [rows, state.rowIdIndex, updateLote])

    return (
        <Box
            sx={{ display: 'flex', flex: 1, flexDirection: 'column', height: '100%', maxHeight: '100vh' }}
            id="selectView"
        >
            <Alerts
                show={showAlert}
                handleClose={closeAlert}
                menssage={msg}
                tipoAlerta={status === "error" ? "error" : "info"}
            />
            <AppBar position="relative" elevation={elevation} >
                <Toolbar variant={variantToobar} key={"toolbar-main-child-view"}>
                    {showButtonBack && (
                        <IconButton
                            size="medium"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            onClick={handleClose}
                        >
                            <ArrowBack />
                        </IconButton>

                    )}
                    {buttonNew.show && (
                        <IconButton
                            size="medium"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            onClick={buttonNew.onClick}
                        >
                            <AddCircleOutline />
                        </IconButton>
                    )}
                    <Stack display={"flex"} flex={1} flexDirection={"column"} width={100}>
                        <Typography
                            noWrap
                            variant="h6"
                            component={"div"}
                            className={classes.title}
                            onDoubleClick={handleClickOculto}
                        >
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography
                                noWrap
                                variant="caption"
                                component={"div"}
                                className={classes.title}
                            >
                                {subtitle}
                            </Typography>
                        )}
                    </Stack>
                    {showUpdateLote && (
                        <FormControlLabel
                            control={<Switch checked={updateLote} onChange={(event) => { handleSetUpdateLote(event.target.checked) }} />}
                            label={
                                <Typography
                                    noWrap
                                    variant="caption"
                                    component={"div"}
                                >
                                    {labelEnableUpdateLote ? labelEnableUpdateLote : "Atualizar Lote"}
                                </Typography>
                            }
                        />

                    )}
                    {showSearchContainer && (
                        <SearchContainer>
                            <SearchIconWrapper>
                                {state.loadingFilter ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <Search />
                                )}

                            </SearchIconWrapper>
                            <StyledInputBase
                                id={`localizar-desk-${changeList}`}
                                autoComplete="new-password"
                                autoFocus={false}
                                inputRef={(input: { focus: () => any; }) => {
                                    input && input.focus();
                                }}
                                value={state.textFilter}
                                onChange={event => {
                                    setState(state => ({ ...state, textFilter: event.target.value }))
                                    //setTextSearch(event.target.value);
                                    handleFilterRow(event.target.value)
                                }}
                                onKeyDown={(event) => onKeyDown(event.keyCode)}
                                placeholder={placeholderTextSearch ? placeholderTextSearch : "Localizar…"}
                                inputProps={{ 'aria-label': 'search-desk', _ref_: inputRef, "aria-autocomplete": "none" }}
                            />
                        </SearchContainer>
                    )}
                    {buttonMenu && buttonMenu.show && (
                        <PopupState variant="popover" popupId="popup-menu">
                            {(popupState) => (
                                <React.Fragment>
                                    <Button
                                        {...bindTrigger(popupState)}
                                        variant="contained"
                                        startIcon={buttonMenu.icon}
                                        endIcon={<KeyboardArrowDown />}
                                    >
                                        {buttonMenu.label}
                                    </Button>
                                    <Menu {...bindMenu(popupState)}>
                                        {buttonMenu.menu.map((row, idx) => (
                                            <MenuItem key={idx} onClick={() => { row.onClick(); popupState.close() }}>{row.icon} {row.label}</MenuItem>
                                        ))}
                                    </Menu>
                                </React.Fragment>
                            )}
                        </PopupState>
                    )}
                    {buttonRefresh.show && (
                        <IconButton
                            size="small"
                            edge="end"
                            color="inherit"
                            aria-label="menu"
                            onClick={buttonRefresh.onClick}
                        >
                            <RefreshRounded />
                        </IconButton>
                    )}
                    {showFullFiltroForm && (
                        <IconButton
                            size="small"
                            edge="end"
                            color="inherit"
                            aria-label="menu"
                            sx={{ display: 'none', [theme.breakpoints.up('sm')]: { display: 'flex' } }}
                            onClick={handleShowFiltroForm}
                        >
                            <FilterList />
                        </IconButton>
                    )}
                    {handleClose && !showButtonBack && (
                        <IconButton
                            size="small"
                            edge="end"
                            color="inherit"
                            aria-label="menu"
                            sx={{ display: 'none', [theme.breakpoints.down('sm')]: { display: 'flex' } }}
                            onClick={handleClose}
                        >
                            <Close />
                        </IconButton>
                    )}

                </Toolbar>

                {showSearchContainer && (
                    <Toolbar variant="dense" key={"toolbar-search-container"} sx={{ display: 'none', [theme.breakpoints.down('sm')]: { display: 'flex' } }}>
                        <SearchContainerMobile>
                            <SearchIconWrapper>
                                {state.loadingFilter ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <Search />
                                )}
                            </SearchIconWrapper>
                            <StyledInputBase
                                id={`localizar-mobile-${changeList}`}
                                autoComplete="new-password"
                                autoFocus={false}
                                value={state.textFilter}
                                onChange={event => {
                                    setState(state => ({ ...state, textFilter: event.target.value, loadingFilter: true }))
                                    //setTextSearch(event.target.value);
                                    handleFilterRow(event.target.value)
                                }}
                                onKeyDown={(event) => onKeyDown(event.keyCode)}
                                placeholder={placeholderTextSearch ? placeholderTextSearch : "Localizar…"}
                                inputProps={{ 'aria-label': 'search-mobile' }}
                            />
                        </SearchContainerMobile>
                        {showFullFiltroForm && (
                            <IconButton
                                size="small"
                                edge="end"
                                color="inherit"
                                aria-label="menu"
                                sx={{ display: 'none', [theme.breakpoints.down('sm')]: { display: 'flex' } }}
                                onClick={handleShowFiltroForm}
                            >
                                <FilterList />
                            </IconButton>
                        )}
                    </Toolbar>
                )}

                {showFullFiltroForm && (
                    <Toolbar key={"toolbar-full-filtro-form"}>
                        <FiltroView
                            form={fullFiltroFormParams!.form}
                            showFormFiltro={fullFiltroFormParams!.showFormFiltro}
                            listFieldShow={fullFiltroFormParams!.listFieldShow}
                        />
                    </Toolbar>
                )}
                {rowsUpdateLote && rowsUpdateLote.length > 0 && updateLote && (
                    <Toolbar key={"toolbar-view-form"}>
                        {formUpdateLote ? (
                            <ViewForm {...formUpdateLote} />
                        ) : (
                            <Typography>Formulario não informado</Typography>
                        )}
                    </Toolbar>

                )}
            </AppBar>
            {loading && (
                <LinearProgress />
            )}
            <DialogContent
                id="selectContainer"
                sx={{ display: 'flex', flex: 1, flexDirection: "column", padding: 0, pt: 2 }}
                onScroll={(ev) => {
                    calcShowList(ev.currentTarget.scrollTop, (ev.currentTarget.scrollHeight - ev.currentTarget.offsetHeight));
                }}
            >
                {ViewBeforeGridList && (
                    <ViewBeforeGridList />
                )}

                {/* displayBreakpoints é utilizada para evitar o carregamento de duas listas
                de rowsFilter, 1 no datagrid e outra no showlistdata.
                usando esssa funçao o sistema carrega somente um ou outro, na opcao do display none,
                é carregado os dois, porem sendo visualizado o que estiver de acordo o o tamanho do display
                ocasionando baixa performance. Obrigado! (não ache que foi loucura sua alan, vc pensou direito e testou) */}
                {displayBreakpoints(displayWidth) >= displayBreakpointsValues.sm ? (
                    <Box sx={{ display: 'flex', flex: 1, padding: 0 }}>
                        {loading && state.rowsFilter.length === 0 && (
                            <SkeletonList />
                        )}
                        {!loading && state.rowsFilter.length === 0 && !hidenGridNoData && (
                            <NoDataShow />
                        )}

                        {!loading && state.rowsFilter.length > 0 && (
                            TableListShow(state.rowsFilter)
                        )}
                    </Box>

                ) : (
                    <Box sx={{ display: 'flex', flex: 1 }}>
                        {loading && rows.length === 0 && (
                            <SkeletonList />
                        )}
                        {!loading && rows.length === 0 && (
                            <NoDataShow />
                        )}
                        {!loading && rows.length > 0 && (
                            <ShowListData
                                rowsFilter={state.rowsFilter}
                                rowIndex={state.indexRow}
                                ListItemTextPrimary={ListItemTextPrimary}
                                ListItemAvatar={ListItemAvatar}
                                ListItemTextSecondary={ListItemTextSecondary}
                                actionsOnkeyEnter={actionsOnkeyEnter}
                                checkbox={checkbox}
                                handleRemove={handleRemove}
                                lenghtList={state.sizeShowList}

                            />
                        )}
                    </Box>
                )}
            </DialogContent>
        </Box>
    )
}

interface SelectModalProps extends SelectProps {
    showModal: boolean;
    width: "xs" | "sm" | "md" | "lg" | "xl"
    ContentExtra?: () => JSX.Element
}


class SelectModal extends PureComponent<SelectModalProps> {

    render(): React.ReactNode {
        const { handleClose, showModal, width } = this.props

        return (
            <Dialog
                id="SelectModal"
                PaperComponent={MyPaper}
                onClose={(e, reason) => {
                    if (reason && reason === "backdropClick")
                        return;
                    handleClose && handleClose()
                }}
                open={showModal}
                maxWidth={width}
                fullScreen={true}
                fullWidth
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus

            >
                <Select
                    {...this.props}

                />
            </Dialog>
        )

    }
}

export default SelectModal


